
import {defineComponent,ref,Ref,computed,ComputedRef, onUnmounted, onMounted, watch} from 'vue'
import { useI18n } from 'vue-i18n'
import {useStore} from 'vuex'
import { EditOutlined, MobileOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'

import Personal from './component/personal/index.vue'
import Enterprise from './component/enterprise/index.vue'
import Password from './component/password/index.vue'
import Phone from './component/phone/index.vue'

import { StateType as UserStateType } from "@/store/user"
import { StateType as FddsignStateType } from "@/store/fddsign"

import {ShipmentOrderType} from '@/services/data.d'

interface PersonalCenterSetupData {
    t: (key: string | number) => string;
    showflag: Ref<boolean>;
    visible: Ref<boolean>;
    fvisible: Ref<boolean>;
    title: ComputedRef<string>;
    typeT: Ref<string>;
    regEmail: Ref<string>;
    certStatus: Ref<number | null>;
    contStatus: Ref<number>;
    userType: Ref<number>;
    userCode: Ref<string>;
    phone: Ref<string>;
    isMark: Ref<boolean>;
    fddurl: Ref<string>;
    handleChange: (e: MouseEvent) => void;
    handleModify: (type: string) => void;
    getStatus: (value: boolean) => void;
    handleSignModal: (e: MouseEvent) => void;
    getClickData: (val: boolean) => void;
    handleCancel: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'PersonalCenter',
    components: {
        Personal,
        Enterprise,
        Password,
        Phone,
        EditOutlined,
        MobileOutlined
    },
    setup(): PersonalCenterSetupData {
        const { t } = useI18n()
        const store = useStore<{user:UserStateType, fddsign:FddsignStateType}>()
        const showflag = ref<boolean>(true)
        const visible = ref<boolean>(false)
        const fvisible = ref<boolean>(false)
        const typeT = ref<string>('')
        const usermsg = JSON.parse(String(localStorage.getItem('userMsg')))
        const regEmail = ref<string>(usermsg?.email)
        const certStatus = ref<number | null>(usermsg?.certStatus ?? null)
        const userCode = ref<string>(usermsg?.userCode)
        const userType = ref<number>(usermsg?.userType ? usermsg?.userType : 1)
        const contStatus = ref<number>(usermsg?.contStatus)
        const phone = ref<string>(usermsg?.phone)
        const isMark = ref<boolean>(false)


        //弹框标题
        const title = computed<string>(():string=>{
            const title = {
                pwd: t('page.personal.center.title.changepassword'),
                bind: t('page.personal.center.title.bindphone'),
                phone: t('page.personal.center.title.changephone')
            }
            return title[typeT.value]
        })

        //选择客户类型
        const handleChange = (e: MouseEvent) => {
            e.preventDefault()
            localStorage.setItem('userType', String(userType.value))
            userType.value == 1 ? showflag.value = true : showflag.value = false
        }

        //显示弹框
        const handleModify = (type: string) => {
            typeT.value = type
            visible.value = true
        }

        //提交后修改状态
        const getStatus = (value: boolean) => {
            const newUserMsg = JSON.parse(String(localStorage.getItem('userMsg')))
            value ? certStatus.value = newUserMsg.certStatus : null
        }

        //法大合同签署
        const url = computed<string>(() => store.state.fddsign.signUrl)
        const fddAction = async(params:ShipmentOrderType) => {
            try {
                const res: boolean = await store.dispatch('fddsign/fddContractFn', params)
                if(res ===  true){
                    fvisible.value = true
                }else{
                    fvisible.value = false
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //点击合同签署弹框
        const handleSignModal = (e: MouseEvent) => {
            e.preventDefault()
            Modal.confirm({
                title: '提示',
                content: '您还未进行合同签署，点击“合同签署”进行签署',
                okText: '合同签署',
                cancelText: '取消',
                onOk(){
                    fddAction({userCode: usermsg.userCode})
                },
            })
        }

        //获取用户信息
        const userinfo = computed<any>(()=> store.state.user.currentUser)
        const getuserinfo = async(params:any) => {
            try {
                const res:boolean = await store.dispatch('user/fetchCurrent',params)
                if(res===true){
                    phone.value = userinfo.value.phone
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }
        //返回结果
        const getClickData = (val: boolean) => {
            if(val){
                getuserinfo({userCode: usermsg.userCode})
            }
        }
        watch(phone,(newValue)=>{
            phone.value = newValue
        })

        onMounted(() => {
            getuserinfo({userCode: usermsg.userCode})
            userType.value == 1 || userType.value == 0 ? showflag.value = true : showflag.value = false
        })

        onUnmounted(() => {
            localStorage.removeItem('userType')
        })

        //点击右上角关闭按钮回调
        let timer:any = null
        const handleCancel = (e: MouseEvent) => {
            localStorage.setItem('signed','true')
            isMark.value = true
            let num = 0
            timer = setInterval(()=>{
                num += 1
                if(num >= 5){
                    isMark.value = false
                    num = 0
                    clearInterval(timer)
                    location.reload()
                }
            },1000)
        }

        return {
            t,
            showflag,
            visible,
            fvisible,
            title,
            typeT,
            regEmail,
            certStatus,
            contStatus,
            userCode,
            userType,
            phone,
            isMark,
            fddurl:url,
            handleChange,
            handleModify,
            getStatus,
            handleSignModal,
            getClickData,
            handleCancel
        }
    }
})
